import { rgba } from 'polished';
import 'quill/dist/quill.bubble.css';
import { createGlobalStyle } from 'styled-components';

import { tokens } from '../../../theme/tokens';

export const BoxedStyling = createGlobalStyle`
	.ql-boxed {
		:not(.ql-readonly) .ql-wrapper {
			position: relative;
		}

		.md-headline, h2, .md-title, h3, .md-subheading-2, h4, .md-subheading-1, h5, .md-body-2, h6, .md-body-1, p {
			color: inherit !important;
		}

		a {
			color: ${(props) => props.theme.colors.primary};
			text-decoration: underline;
		}


		.ql-editor,
		.ql-editor.ql-blank {
			white-space: pre-wrap;
			padding: 0px;
			min-height: 100px;
			word-break: break-word;

			p,
			li {
				font-size: 15px;
			}

			ul, ol {
				margin: 0;
				padding: 0;
			}

			img {
				max-height: 300px;
				max-width: 100%;
				border-radius: 4px;
			}

			iframe {
				height: 200px;
				max-width: 100%;
				border-radius: 4px;
			}

			outline: none;
		}

		.ql-container, p {
			font-family: inherit !important;
		}

		.ql-container .ql-tooltip {
			background: ${rgba(tokens.text.secondary, 0.8)};
			backdrop-filter: blur(2px);
			z-index: 1000000;
		}


		.ql-container .ql-tooltip .ql-formats .ql-active {
			background-color: ${(props) => props.theme.colors.primary};
			border-radius: 100px;
		}
		.ql-container .ql-tooltip .ql-formats .ql-active svg .ql-stroke {
			stroke: ${(props) => props.theme.colors.white};
		}

		.ql-container .ql-tooltip .ql-formats .ql-active svg .ql-fill {
			fill: ${(props) => props.theme.colors.white};
		}

		.ql-container .ql-tooltip .ql-formats button svg .ql-stroke {
			stroke: white;
		}

		.ql-container .ql-tooltip .ql-formats button svg .ql-fill {
			fill: white;
		}



		.ql-container.ql-snow {
			border: none !important;
		}

		.ql-clipboard {
			display: block;
			left: -100000px;
			height: 1px;
			overflow-y: hidden;
			position: absolute;
			top: 50%;
		}
	}

	.ql-editor.ql-blank::before {
		color: rgba(0, 0, 0, 0.3);
		font-style: normal;
		font-size: 15px;
	}

	.ql-wide {
		width: 100%;
	}
`;

export const ReadOnlyStyling = createGlobalStyle`
	.ql-readonly {
		color: ${tokens.text.secondary};
		cursor: auto;

		ul, ol {
			margin: 0;
			padding: 0;
		}

		.ql-container, .ql-editor {
			min-height: auto !important;
		}

		.ql-editor a {
			cursor: pointer !important;
		}

		.ql-editor * {
			cursor: inherit !important;
		}
	}
`;
